import PreviewReview from '@/pages/PreviewReview';
import { RouteType } from '@/lib/route';

const PreviewReviewRoutes: RouteType = {
  path: '/preview-review/:tenantId/:elearningId/:type/:frameId?',
  component: PreviewReview,
};

export interface PreviewReviewParamType {
  tenantId: string;
  elearningId: string;
  type: 'review' | 'live' | 'scorm';
  themeId: string;
  frameId: string;
}

export default PreviewReviewRoutes;
